import { redirect } from '../../utils/url';

/**
 * @param {String} url
 * @param {String} appName
 * @param {String} expHash
 * @returns {String}
 */
function getExperimentalUrl(url, appName, expHash) {
  return url.replace(
    `static/${appName}/`,
    `static/global/exp/${appName}/${expHash}/index.html`
  );
}

/**
 * Redirect to an experimental URL if the experiment exists
 * @param {Object} 
 * @returns {Promise}
 */
export default function setup({ name, href }) {
  const expHash = __lift.experiments.getExperimentHash(name);

  if (expHash && !href.includes('exp')) {
    redirect(getExperimentalUrl(href, name, expHash));
    return Promise.reject();
  }
  return Promise.resolve(true);
}
